export const CHANGE_X = "Change X";
export const CHANGE_Y = "Change Y";
export const CHANGE_BLUR = "Change Blur";
export const CHANGE_COLOR = "Change Color";
export const CHANGE_SPREAD = "Change Spread";
